/*
 * Faceted Filter Dropdown — mobile bottom-sheet for filter selection.
 *
 * Architecture:
 * - Event delegation on document (robust against load-order issues, dynamic DOM).
 * - Open via any [data-mobile-filter-trigger]
 * - Close via [data-mobile-filter-close] (X button, backdrop overlay) or Escape.
 * - Apply via [data-mobile-filter-apply] — finds the form, requests submit.
 * - Single submit interceptor rebuilds URL preserving non-filter params
 *   (sort_by, page, etc.) and navigates.
 */
(function () {
  'use strict';

  function getDropdown() {
    return document.querySelector('faceted-filter-dropdown');
  }

  function openFilter() {
    var el = getDropdown();
    if (!el) {
      console.warn('[faceted-filter] dropdown element not found in DOM');
      return;
    }
    el.classList.add('open');
    document.body.classList.add('ffd-open');
  }

  function closeFilter() {
    var el = getDropdown();
    if (!el) return;
    el.classList.remove('open');
    document.body.classList.remove('ffd-open');
  }

  /* Click delegation — handle open / close / apply via single handler */
  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;

    if (e.target.closest('[data-mobile-filter-trigger]')) {
      e.preventDefault();
      openFilter();
      return;
    }

    if (e.target.closest('[data-mobile-filter-close]')) {
      e.preventDefault();
      e.stopPropagation();
      closeFilter();
      return;
    }

    if (e.target.closest('[data-mobile-filter-apply]')) {
      e.preventDefault();
      var dd = getDropdown();
      var form = dd && dd.querySelector('[data-faceted-filter-form]');
      if (form) {
        if (typeof form.requestSubmit === 'function') {
          form.requestSubmit();
        } else {
          form.submit();
        }
      }
    }
  });

  /* Escape closes the sheet */
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      var el = getDropdown();
      if (el && el.classList.contains('open')) closeFilter();
    }
  });

  /*
   * Submit interceptor: intercepts ANY [data-faceted-filter-form] submission
   * (mobile sheet apply, desktop per-group apply buttons), rebuilds URL
   * preserving non-filter params, navigates.
   */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.matches || !form.matches('[data-faceted-filter-form]')) return;
    e.preventDefault();

    var formData = new FormData(form);
    var newParams = new URLSearchParams();
    formData.forEach(function (value, key) {
      if (value !== '' && value != null) newParams.append(key, value);
    });

    var existingParams = new URLSearchParams(window.location.search);
    existingParams.forEach(function (value, key) {
      if (!key.startsWith('filter.')) newParams.append(key, value);
    });

    var qs = newParams.toString();
    window.location.search = qs ? '?' + qs : '';
  });

  /* Keep the custom element defined for CSS selector targeting */
  if (typeof customElements !== 'undefined' && !customElements.get('faceted-filter-dropdown')) {
    customElements.define('faceted-filter-dropdown', class extends HTMLElement {});
  }
})();
